<script setup lang="ts">
import { computed } from 'vue';

export interface KaLoaderProps {
  size?: 'small' | 'normal' | 'big';
  color?: 'gray' | 'white';
}

const props = withDefaults(defineProps<KaLoaderProps>(), {
  color: 'gray',
  size: 'normal',
});

const isSmall = computed(() => props.size === 'small');
const isBig = computed(() => props.size === 'big');
const isNormal = computed(() => props.size === 'normal');
</script>

<template>
  <div
    class="flex items-center justify-center"
    :class="{ 'space-x-0.5': isSmall, 'space-x-1': isNormal || isBig }"
  >
    <div
      v-for="dot in 3"
      :key="dot"
      class="ka-loading-dots rounded-full"
      :class="{
        'h-[0.3125rem] w-[0.3125rem]': isSmall,
        'h-2 w-2': isNormal,
        'h-2.5 w-2.5': isBig,
        'ka-animation-delay-200': dot === 2,
        'ka-animation-delay-400': dot === 3,
        'bg-gray-400': props.color === 'gray',
        'bg-white': props.color === 'white',
      }"
    ></div>
  </div>
</template>

<style>
@keyframes kaDots {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
    scale: 1.1;
  }
  100% {
    opacity: 0.2;
  }
}
.ka-loading-dots {
  animation: kaDots 1.4s ease-in-out infinite backwards;
}
.ka-animation-delay-200 {
  animation-delay: 200ms;
}
.ka-animation-delay-400 {
  animation-delay: 400ms;
}
</style>
